import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Dialog, Divider, Box, TextField } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { userFeedback } from "../../redux/slice/user-feedback";
import { getUserChats } from "../../redux/slice/get-user-chats";
import "./UnlikeDialog.scss";
import { useLocation } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow:
    "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  backgroundColor: "#f5f8fa",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
    ...theme.applyStyles("dark", {
      backgroundColor: "#30404d",
    }),
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: "rgba(206,217,224,.5)",
    ...theme.applyStyles("dark", {
      background: "rgba(57,75,89,.5)",
    }),
  },
  ...theme.applyStyles("dark", {
    boxShadow: "0 0 0 1px rgb(16 22 26 / 40%)",
    backgroundColor: "#394b59",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))",
  }),
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#6D94A7",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&::before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#6D94A7",
  },
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const dropdownValues = [
  {
    value: "Response is incorrect",
    label: "Response is incorrect",
  },
  {
    value: "Does not answer the question",
    label: "Does not answer the question",
  },
  {
    value: "Confusing or unintuitive structure",
    label: "Confusing or unintuitive structure",
  },
  {
    value: "Extraneous information",
    label: "Extraneous information",
  },
  {
    value: "Guardrail is needed",
    label: "Guardrail is needed",
  },
  {
    value: "Insufficient context in response",
    label: "Insufficient context in response",
  },
  {
    value: "Other",
    label: "Other",
  },
];
export default function UnlikeDialog(props) {
  const { open, handleClose, chatId, userSessionId } = props;
  const dispatch = useDispatch();
  const [value, setValue] = React.useState("");
  const [selectedValue, setSelectedValue] = React.useState("");
  // const [selectedValue, setSelectedValue] = React.useState("");
  const [selectedValues, setSelectedValues] = React.useState([]);

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const userEmail = authUser?.email || "";
  const token = "__cookie__";
  // const client = queryParams.get("client");
  const client = "UT";
  // const handleChange = (event) => {
  //   setSelectedValue(event.target.value);
  // };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedValues((prev) =>
      checked ? [...prev, value] : prev.filter((v) => v !== value),
    );
  };

  const dispatchFeedbackAction = () => {
    const payload = {
      feedback: false, // ✅ boolean
      rating: 0, // ✅ optional (0–5)
      feedback_text: value || "", // ✅ string
      feedback_option: selectedValues.join(", "), // ✅ string label(s)
    };

    const param = {
      sessionId: userSessionId,
      chatId: chatId,
      data: payload,
      token,
      userEmail,
      client,
    };

    const payloadForUserSession = {
      sessionId: userSessionId,
      userEmail,
      token,
      client,
    };

    dispatch(userFeedback(param))
      .unwrap()
      .then(() => {
        return dispatch(getUserChats(payloadForUserSession));
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    handleClose();
    setSelectedValues([]);
    setValue("");
  };

  const handleCloseDialog = () => {
    handleClose();
    // setSelectedValue(0);
    setSelectedValues([]);
    setValue("");
  };
  return (
    <BootstrapDialog
      onClose={handleCloseDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="sm"
      fullWidth="true"
      className="unlike-dialog-parent"
    >
      <DialogTitle id="customized-dialog-title" className="unlike-dialog-title">
        Submit feedback
      </DialogTitle>
      <Typography
        className="unlike-dialog-sub-title"
        sx={{ pl: 2, fontSize: "12px", color: "#6F6F6F" }}
      >
        Give me much details you can, but do not include any private or
        sensitive information.
      </Typography>
      <IconButton
        aria-label="close"
        onClick={handleCloseDialog}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className="unlike-dialog-content">
        <Typography sx={{ fontSize: "14px" }}>
          I didn't like the response because:
        </Typography>
        <FormControl className="unlike-dialog-form-control">
          {/* <RadioGroup
            aria-labelledby="demo-customized-radios"
            name="customized-radios"
            row
            value={selectedValue}
            onChange={(e) => handleChange(e)}
            className="unlike-dialog-radio-parent"
          >
            {dropdownValues.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<BpRadio />}
                label={option.label}
                className="unlike-dialog-radio-button"
              />
            ))}
          </RadioGroup> */}
          <FormGroup row className="unlike-dialog-checkbox-parent">
            {dropdownValues.map((option) => (
              <FormControlLabel
                key={option.value}
                label={option.label}
                sx={{
                  minWidth: "265px",
                  "& .MuiFormControlLabel-label": { fontSize: "14px" },
                }}
                control={
                  <Checkbox
                    value={option.value}
                    checked={selectedValues.includes(option.value)}
                    onChange={handleCheckboxChange}
                    sx={{ "&.Mui-checked": { color: "#6D94A7" } }}
                  />
                }
                className="unlike-dialog-checkbox"
              />
            ))}
          </FormGroup>
        </FormControl>
        <TextField
          id="outlined-multiline-static"
          placeholder="What’s the issue with the response?(min 5 characters required)"
          multiline
          rows={4}
          value={value}
          fullWidth
          onChange={(e) => setValue(e.target.value)}
          sx={{ marginBottom: "30px" }}
        />
        <Divider />
        <Box className="unlike-dialog-buttons-holder">
          <Button
            variant="outlined"
            size="large"
            className="unlike-dialog-cancel-button"
            onClick={handleCloseDialog}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="large"
            className="unlike-dialog-submit-button"
            onClick={dispatchFeedbackAction}
            disabled={!(value.length >= 5)}
          >
            Submit
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
}

// Inspired by blueprintjs
function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}
